import toast from "react-hot-toast";
import  {client} from "@/app/ApolloClient";
import {gql} from "@apollo/client";


var query = gql`
   query applicationHistory($organizationId: UUID!, $applicationId: UUID!, $page: Int) {
          applicationHistory(
            organizationId: $organizationId
            applicationId: $applicationId
            page: $page
          ) {
            nodes {
              account_id
              account_name
              application_id
              id
              message
              organization_id
              timestamp
              type
            }
            pageInfo {
              endCursor
              hasNextPage
              hasPreviousPage
              startCursor
            }
            totalCount
          }
   }
`;



export function apiGetApplicationHistory(organizationId, applicationId, page) {
    return new Promise(async (resolve, reject) => {
        if(!organizationId) reject("organizationId is required");

        page ??= 0;

        client
            .query({
                query: query,
                variables: {organizationId, applicationId, page},
                errorPolicy: "ignore",
                fetchPolicy: "network-only"
            })
            .then( (result) =>  JSON.parse(JSON.stringify(result?.data?.applicationHistory)))
            .then((result) => {
                resolve(result);
            })
            .catch((err) => {
                toast.error("Api Error, Unable to get application history");
                reject(err); // R
            })
    });
}
